import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Grid, Typography, Button, TextField } from "@mui/material";
import { APP_ROUTES, MAIN_ROUTES } from "../../../../_config/routes";
import { validateOrderDate } from "../../../../_events/orders/order_box.input";
import { message } from 'antd';
import { findAllByGroupDetailsOrderEvent, findOrdersIdsByCompanyAndDateEvent, findOrdersIdsByCompanyEvent } from "../../../../_events/orders/find_order.event";
import GroupOrderList from "./group_order_list";
import InfoOrderModal from "./modals/info_order_modal";
import { updateOrderDetailEvent, viewInfoDetailsEvent } from "../../../../_events/orderDetail/orderDetail.event";
import ModalCutInfo from "./modals/info_cut_modal";
import { findAllColors } from "../../../../_events/color/find_colors.event";
import { findAllProcessStateEvent } from "../../../../_events/process_state/find_process_state.event";
import UpdateOrderDetailModal from "./modals/update_orderDetail_modal";
import { findProductsByCompanyEvent, findProductsPriceByClientEvent } from "../../../../_events/products/findProducts.event";
import UpdateOrderModal from "./modals/update_order_modal";
import { editOrderEvent } from "../../../../_events/orders/edit.event";
import { deleteOrdersEvent } from "../../../../_events/orders/order_box.event";

const OrdersHistoryGroupOrder = () => {
    const [loading, setLoading] = useState(false);
    const [orders, setOrders] = useState(false);

    const [dateStart, setDateStart] = useState(false);
    const [dateEnd, setDateEnd] = useState(false);
    const [filteredOrders, setFilteredOrders] = useState(false);

    const [order, setOrder] = useState(false);
    const [openModalOrder, setOpenModalOrder] = useState(false);

    const [cutInfo, setCutInfo] = useState(false);
    const [openCutModal, setOpenCutModal] = useState(false);

    const [orderDetailUpdate, setOrderDetailUpdate] = useState(false);
    const [openUpdateODModal, setOpenUpdateODModal] = useState(false);

    const [processList, setProcessList] = useState(null);
    const [colorList, setColorList] = useState(null);
    const [productPriceList, setProductPriceList] = useState(null);

    const [openModalEditOrder, setOpenModalEditOrder] = useState(null);
    const [orderUpdate, setOrderUpdate] = useState(null);


    const findOrderIds = () => {
        setLoading(true);
        findOrdersIdsByCompanyEvent()
            .then((data) => {
                setOrders(data.list);
                setLoading(false);
            })
            .catch((err) => {
                message.err(err);
                setLoading(false);
            });

    };


    const findInfoOrder = (uuid_order) => {
        setOpenModalOrder(true);
        findAllByGroupDetailsOrderEvent(uuid_order)
            .then((data) => {
                setOrder(data.list);
            })
            .catch((err) => {
                setOpenModalOrder(false);
                message.error(err.message);
            });
    };

    const searchCutInfo = (uuid_details) => {
        viewInfoDetailsEvent(uuid_details)
            .then(data => {
                setOpenCutModal(true);
                setCutInfo(data.data);
            }).catch((err) => {
                setOpenCutModal(false);
                message.error(err);
            })
    }

    const handleCloseCutModal = () => {
        setCutInfo(false);
        setOpenCutModal(false);
    }

    const editOrderDetail = (orderDetail) => {
        setOpenUpdateODModal(true);
        findAllColors()
            .then((data) => {
                setColorList(data.list);
            })
            .catch((err) => {
                message.error(err)
            })
        findAllProcessStateEvent()
            .then((data) => {
                setProcessList(data.list);
            })
            .catch((err) => {
                message.error(err)
            })
        findProductsPriceByClientEvent(orderDetail.productPrice.client.uuid)
            .then((data) => {
                setProductPriceList(data.list)
            })
        setOrderDetailUpdate(orderDetail);
    }


    const updateOrderDetail = (dataUpdate) => {
        updateOrderDetailEvent(dataUpdate, orderDetailUpdate)
            .then((data) => {
                handleCloseUpdateOrderDetail();
                if (!data.ok) {
                    message.error('Error en la actualizacion')
                } else {
                    message.success('Registro actualizado')
                }
            })
            .catch((err) => {
                message.error(err)
            })
    }

    const findOrderByDate = (dateStart, dateEnd) => {
        setLoading(true);
        findOrdersIdsByCompanyAndDateEvent(dateStart, dateEnd)
            .then((data) => {
                setDateEnd(dateEnd);
                setDateStart(dateStart);
                setOrders(data.list);
                setLoading(false);
            })
            .catch((err) => {
                message.err(err);
                setLoading(false);
            });

    };

    const cleanFilters = () => {
        setDateEnd(false);
        setDateStart(false);
        findOrderIds();
        setFilteredOrders(null);
    }

    const filterOrders = (filterValue) => {
        const filter = orders
            ? orders.filter((order) =>
                order.id.toLowerCase().includes(filterValue.toLowerCase())
            )
            : [];

        setFilteredOrders(filter);
    }

    const editOrder = (order) => {
        setOrderUpdate(order);
        setOpenModalEditOrder(true);
    }

    const handleCloseModalEditOrder = () => {
        setOpenModalEditOrder(false);
        setOrderUpdate(false)
    }

    const updateOrder = (inputs) => {
        editOrderEvent(orderUpdate.uuid, inputs)
            .then((data) => {
                handleCloseModalEditOrder();
                handleCloseModalOrder();
                message.success('Orden editada')
            })
            .catch((err) => {
                message.err(err);
                setLoading(false);
            });

    }

    const deleteOrder = (uuid_order) => {
        deleteOrdersEvent(uuid_order)
        .then(data => {
            message.success('Orden eliminada');
            findOrderIds();
            handleCloseModalOrder();
        })
        .catch(err => {
            message.error(err.message);
        });
    }

    const InputsDates = () => (
        <div>
            <TextField
                style={{ marginLeft: '15px' }}
                label="Fecha de inicio"
                type="date"
                id="dateStart"
                InputLabelProps={{
                    shrink: true,
                }}
            />
            <TextField
                style={{ marginLeft: '15px' }}
                label="Fecha final"
                type="date"
                id="dateEnd"
                InputLabelProps={{
                    shrink: true,
                }}
            />
            <Button
                style={{ marginLeft: '15px', marginTop: "10px" }}
                variant="contained"
                size="small"
                onClick={() => {
                    try {
                        const dateStart = document.getElementById('dateStart').value;
                        const dateEnd = document.getElementById('dateEnd').value;
                        validateOrderDate(dateStart, dateEnd);
                        findOrderByDate(dateStart, dateEnd);
                    } catch (error) {
                        message.error(error.message);
                    }
                }}
            >
                Buscar
            </Button>
            <Button
                style={{ marginLeft: '15px', marginTop: "10px" }}
                variant="contained"
                size="small"
                onClick={() => {
                    cleanFilters()
                }}
            >
                Limpiar filtro
            </Button>
        </div>
    );

    const handleCloseModalOrder = () => {
        setOrder(null);
        setOpenModalOrder(false);
    }

    const handleCloseUpdateOrderDetail = () => {
        setOpenUpdateODModal(false);
        setOrderDetailUpdate(null);
        setOpenCutModal(false);
        setColorList(null);
        setProcessList(null);
        setProductPriceList(null);
        setOpenModalOrder(false);
    };

    const inputStyle = {
        padding: "8px",
        borderRadius: "4px",
        border: "1px solid #ccc",
        marginRight: "10px",
        fontSize: "14px",
        width: "200px",
        outline: "none",
    };

    useEffect(() => {
        findOrderIds();
    }, []);

    return (
        <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
                <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                    <Typography variant="h6" component="h6">
                        Listado de Ordenes
                    </Typography>
                    <div style={{ flexWrap: 'wrap' }}>
                        {/** 
                        <Link to={`${MAIN_ROUTES.app_modules}${APP_ROUTES.orders_history_group_date}`}>
                            <Button style={{ margin: '5px' }} variant="contained" size="small">Agrupación fecha</Button>
                        </Link>
                        */}
                        <Link to={`${MAIN_ROUTES.app_modules}${APP_ROUTES.orders_history_group_client}`}>
                            <Button style={{ margin: '5px' }} variant="contained" size="small">Agrupación cliente</Button>
                        </Link>
                        <Link to={`${MAIN_ROUTES.app_modules}${APP_ROUTES.orders_history}`}>
                            <Button style={{ margin: '5px' }} variant="contained" size="small">Agrupacion orden</Button>
                        </Link>
                    </div>
                </div>
                <hr />
                {loading ? (
                    'Cargando...'
                ) : (
                    <div>
                        <div style={{ flexDirection: 'row' }}>
                            <div style={{ display: "flex", marginTop: "30px", marginBottom: "12px" }}>
                                <div style={{ alignItems: "center", flex: 1 }}>
                                    <InputsDates />
                                </div>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <p style={{ marginRight: "10px" }}>Numeros de orden:</p>
                                    <input
                                        type="text"
                                        placeholder="Buscar numero de order"
                                        style={inputStyle}
                                        onChange={(e) => filterOrders(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>


                        <GroupOrderList
                            orders={filteredOrders ? filteredOrders : orders}
                            dateStart={dateStart}
                            dateEnd={dateEnd}
                            findInfoOrder={(uuid_order) => findInfoOrder(uuid_order)}
                        />

                        {
                            !order ? null :
                                (
                                    <InfoOrderModal
                                        openModalOrder={openModalOrder}
                                        order={order}
                                        handleCloseModalOrder={handleCloseModalOrder}
                                        searchCutInfo={(uuid_details) => searchCutInfo(uuid_details)}
                                        editOrder={(order) => editOrder(order)}
                                        deleteOrder={(uuid_order)=>deleteOrder(uuid_order)}
                                    />
                                )
                        }

                        {
                            !cutInfo ? null :
                                (
                                    <ModalCutInfo
                                        cutInfo={cutInfo}
                                        openCutModal={openCutModal}
                                        handleCloseCutModal={handleCloseCutModal}
                                        editOrderDetail={(od) => (editOrderDetail(od))}
                                    />
                                )

                        }

                        {
                            !orderDetailUpdate ? null :
                                (
                                    <UpdateOrderDetailModal
                                        openUpdateODModal={openUpdateODModal}
                                        orderDetailUpdate={orderDetailUpdate}
                                        handleCloseUpdateOrderDetail={handleCloseUpdateOrderDetail}
                                        updateOrderDetail={(body) => updateOrderDetail(body)}
                                        processList={processList}
                                        colorList={colorList}
                                        productPriceList={productPriceList}
                                    />
                                )
                        }

                        {
                            !orderUpdate ? null :
                                (
                                    <UpdateOrderModal
                                        order={orderUpdate}
                                        handleCloseModalEditOrder={handleCloseModalEditOrder}
                                        openModalEditOrder={openModalEditOrder}
                                        updateOrder={(inputs) => updateOrder(inputs)}
                                    />
                                )
                        }

                    </div>

                )}


            </Grid>
        </Grid>
    );
}

export default OrdersHistoryGroupOrder;
